import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { ArticleComponent } from './article/article.component'
import { ArticlesRoutingModule } from './articles-routing.module'
import { SharedModule } from '../shared/shared.module'
import { TagsModule } from '../libs/tags/tags.module'
import { FloPipeModule } from '../shared/pipes/flo-pipe.module'
import { AuthorDateModule } from '../shared/author-avatar/author-date/author-date.module'
import { ContentSmallModule } from '../libs/content-small/content-small.module'
import { ArticleViewComponent } from './article/article-view/article-view.component'
import { SlimHeaderModule } from '../libs/slim-header/slim-header.module'
import { PaywallModule } from '../shared/paywall/paywall.module'
import { ArticleListViewComponent } from './article-list/article-list-view/article-list-view.component'
import { IsoStringToDatePipeModule } from '../libs/iso-string-to-date-pipe/iso-string-to-date-pipe.module'
import { VideoPlayerModule } from '../shared/video-player/video-player.module'
import { ArticleListComponent } from './article-list/article-list.component'
import { PrimaryRelatedContentModule } from '../libs/primary-related-content/primary-related-content.module'
import { TwitterShareIconComponent } from './article/article-view/twitter-share-icon/twitter-share-icon.component'
import { FacebookShareIconComponent } from './article/article-view/facebook-share-icon/facebook-share-icon.component'
import { SvgModule } from '../shared/svg/svg.module'
import { StaticContentCardModule } from '../libs/content-card/static-content-card/static-content-card.module'
import { AdhesionFooterModule } from '../libs/adhesion-footer/adhesion-footer.module'

// prettier-ignore
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ArticlesRoutingModule,
    SharedModule,
    TagsModule,
    FloPipeModule,
    AuthorDateModule,
    ContentSmallModule,
    SlimHeaderModule,
    IsoStringToDatePipeModule,
    VideoPlayerModule,
    PaywallModule,
    PrimaryRelatedContentModule,
    SvgModule,
    StaticContentCardModule,
    AdhesionFooterModule
  ],
  declarations: [
    ArticleComponent,
    ArticleListComponent,
    ArticleViewComponent,
    ArticleListViewComponent,
    TwitterShareIconComponent,
    FacebookShareIconComponent,
  ]
})
export class ArticlesModule {}
